<template>
  <TabsLayout>
    <ElTabPane name="appslist" label="游戏应用管理"></ElTabPane>
    <ElTabPane
      name="appsadd"
      :label="`${$route.query.t === 'edit' ? '修改' : '新建'}游戏应用`"
      v-if="$route.name === 'appsadd'"
    ></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'appmanagelayout',
  components: { TabsLayout }
}
</script>
